import { render, staticRenderFns } from "./RouteView.vue?vue&type=template&id=66b3006a&"
import script from "./RouteView.vue?vue&type=script&lang=js&"
export * from "./RouteView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports